<template>
    <div>

        <h1>{{ module.module.name }}</h1>
        <div class="result-container">
        <b-container fluid="md" class="result col-md-7">
            <h4>{{ resultTitle[textIndex] }}</h4>
            <p>{{ resultText[textIndex] }}</p>
            <div class="button-group">
                <b-button class="h-100" variant="secondary" :to="{ name: 'Dashboard' }">Revenir au tableau de bord</b-button>
                <b-button class="h-100" v-if="module.completion<100" variant="secondary" :to="{ name: 'Course', params : { moduleId: module.module.id }}">Consulter le support de formation</b-button>
            </div>
        </b-container>
        <b-container fluid class="progressBar result col-md-5">
        
        <ProgressBar v-if="module.completion>=0" :progress="module.completion" :plus="module.module.is_plus" :order="module.module.order" :exams="exams"></ProgressBar>

        </b-container>
        </div>

        <div v-if="lastExam && lastExam.exam_data" class="to-progress">
            <h5>Voici le récapitulatif de vos réponses pour ce module:</h5>
                <exam-data :exam="examDataToDisplay"></exam-data>
        </div>
    </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'
import api from '@/services/api.js'
import ExamData from '../components/ExamData.vue'
export default {
  components: {
    ProgressBar,
    ExamData
  },
  data () {
    return {
        module: {
            module: {
                id: parseInt(this.$route.params.id),
                name: '',
            },
            exams:{}
        },
        lastExam: {},
        resultTitle : [
           "N'abandonnez pas !",
           "Vous êtes sur la bonne voie !",
           "Encore un petit effort !",
           "Félicitations !"
        ],
        resultText :  [
           "Il semblerait que vous ayez besoin de vous replongez dans votre cahier d'apprentissage. Celui-ci est accessible directement depuis votre tableau de bord. N'hésitez pas à demander de l'aide à votre référent lorsque vous rencontrez certaines difficultés. Ne vous laissez pas décourager!",
           "Vous commencez à cerner l'essentiel du module. N'hésitez pas à consulter votre support de formation en ligne, pour éclaircir certains points qui peuvent vous paraître abstraits. Continuez comme ça!",
           "La réussite est proche! Il vous reste quelques détails à revoir pour valider ce module. Vous y êtes presque, n'abandonnez pas!",
           "Vous avez réussi! Ce module est validé et n'a plus de secret pour vous. Une étape de plus franchie dans l'acquisition de vos nouvelles compétences numériques. Savourez cette victoire!"
        ],
    }
  },
  computed: {
    exams () {
        // Converti l'objet module.exams en tableau pour empêcher d'obtenir une erreur dans la console.
        return Object.keys(this.module.exams).map((key) => {
            return this.module.exams[key]
        })
    },
    examDataToDisplay () {
        let examDataToDisplay = []
        this.exams.forEach(exam => {
            if (exam.is_ended==true) {
            exam.exam_data.forEach(data => {
                if(data.is_success == true) {
                    examDataToDisplay.push(data)
                }
            });
            }
        });
        this.lastExam.exam_data.forEach(data => {
            if(data.is_success==false) {
                examDataToDisplay.push(data)
            }
        });
        return examDataToDisplay.sort((a,b) => {return a.question_num - b.question_num})
    },
    textIndex () {
        if(this.module.completion < 33) {
            return 0;
        } else if (this.module.completion < 66){
            return 1;
        } else if (this.module.completion < 100){
            return 2;
        } else if (this.module.completion >= 100) {
            return 3;
        } else {return null}
    }
  },
  beforeMount() {
    this.$parent.$parent.setLoading(true, "Chargement de vos résultats")
    api.get(`/module/${this.module.module.id}`)
    .then(response => {
        this.module = response.data[0]
        this.lastExam = (this.module.exams[0] && this.module.exams[0].is_ended==true) ? this.module.exams[0] : (this.module.exams[1] && this.module.exams[1].is_ended==true) ? this.module.exams[1] : null
        this.$parent.$parent.setLoading(false)
    })
    .catch(() => {
        this.$router.push({name: "Dashboard"})
    })
  }
}
</script>

<style scoped>
h1, h5 {
    font-weight: bold;
    word-break: break-word;
}
.to-progress {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: solid 0.5px #777
}
.result-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    margin: 2em auto;
    min-height: 290px;
}
.result {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 1em auto;
}
.progressBar {
  display: block;
}
.button-group {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 2.5rem;
}
.btn {
    display: grid;
    align-items: center;
    width: 40%;
    min-height: 3rem;
}
</style>